export const OVERLAY_GAP_PX = 8;
export const OVERLAY_MARGIN_PX = 8;

export interface OverlayRect {
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly height: number;
}

export interface OverlaySize {
  readonly width: number;
  readonly height: number;
}

/** ツールバー起点のオーバーレイを、可能なら上側へ表示して画面内へ収める。 */
export function resolveOverlayPosition(
  anchor: OverlayRect,
  size: OverlaySize,
  viewport: OverlaySize
): { readonly left: number; readonly top: number } {
  const maxLeft = viewport.width - size.width - OVERLAY_MARGIN_PX;
  const left = Math.max(OVERLAY_MARGIN_PX, Math.min(anchor.left, maxLeft));

  const above = anchor.top - size.height - OVERLAY_GAP_PX;
  const below = anchor.top + anchor.height + OVERLAY_GAP_PX;
  const maxTop = viewport.height - size.height - OVERLAY_MARGIN_PX;
  let top = above;
  if (above < OVERLAY_MARGIN_PX && below + size.height <= viewport.height - OVERLAY_MARGIN_PX) {
    top = below;
  }
  top = Math.max(OVERLAY_MARGIN_PX, Math.min(top, maxTop));
  return { left, top };
}
